import { useEffect, useState, RefObject } from 'react';
import { FixedSizeList } from 'react-window';
import { Row } from 'react-table';

export const useScrollToHighlightedId = <TItem extends Record<string, unknown>>({
  highlightedId,
  rows,
  itemHeight,
  highlightedRowIdOnMount,
  resetHighlightedRowId,
  fixedSizeListRef,
  nonVirtualListRef,
  isVirtualList,
}: {
  highlightedId: string | undefined;
  rows: Row<TItem>[];
  itemHeight: number;
  highlightedRowIdOnMount: string | undefined;
  resetHighlightedRowId: () => void;
  fixedSizeListRef: RefObject<FixedSizeList | null>;
  nonVirtualListRef: RefObject<HTMLDivElement | null>;
  isVirtualList: boolean;
}): void => {
  const [isScrolledAfterMount, setIsScrolledAfterMount] = useState(!highlightedRowIdOnMount);
  const elementRef = isVirtualList ? fixedSizeListRef : nonVirtualListRef;
  useEffect(() => {
    if (!isScrolledAfterMount && elementRef?.current && highlightedId) {
      if (rows.length > 0) {
        const highlightedItemIndex = rows.findIndex(
          (r) => r.id === highlightedId || String(r?.original?.id) === highlightedId,
        );
        if (highlightedItemIndex === -1) {
          void setIsScrolledAfterMount(true);
          resetHighlightedRowId();
        } else {
          const topOffsetShift = itemHeight * 1.5;
          const top = itemHeight * highlightedItemIndex - topOffsetShift;
          if (isVirtualList) {
            void fixedSizeListRef?.current?.scrollTo(top);
          } else {
            void nonVirtualListRef?.current?.scrollTo({ top, behavior: 'smooth' });
          }
          void setIsScrolledAfterMount(true);
        }
      }
    }
  }, [
    highlightedId,
    highlightedRowIdOnMount,
    rows,
    rows?.length,
    isScrolledAfterMount,
    resetHighlightedRowId,
    elementRef?.current,
    isVirtualList,
  ]);
};
